var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column justify-center align-center",attrs:{"height":"100%","elevation":"0"}},[_c('v-card-title',{staticClass:"d-flex justify-center text-h2"},[_vm._v(" "+_vm._s(`👋🏻 歡迎！`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }